/**
 * L'échec d'une demande d'un appareil, vu par la salle (`ParticipantEvent.MediaDevicesError` du participant
 * local) : la connexion, un passage de mode, un clic. Le micro refusé et la caméra refusée l'écoutent, chacun
 * pour sa sorte.
 *
 * L'événement se nomme par sa chaîne : le module de LiveKit ne se charge pas dans un test sans préparation.
 */
import { type LocalParticipant } from "livekit-client"
import { useEffect, useRef } from "react"

export function useMediaDevicesError(
    participant: Pick<LocalParticipant, "on" | "off">,
    kind: MediaDeviceKind,
    onError: (cause: Error) => void
): void {
    const onErrorRef = useRef(onError)
    onErrorRef.current = onError
    useEffect(() => {
        const listener = (cause: Error, failedKind?: MediaDeviceKind) => {
            if (failedKind === kind) onErrorRef.current(cause)
        }
        participant.on("mediaDevicesError", listener)
        return () => {
            participant.off("mediaDevicesError", listener)
        }
    }, [participant, kind])
}
